import styled from '@emotion/styled';
import { Button } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';

import { useDownloadClassroomCsv } from '../../../hooks/use-download-classroom-csv';

import { SchoolClassroomsDropdown } from './school-classrooms-dropdown';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`;

function SchoolClassroomsHeader() {
  const { t } = useTranslation();

  const { onDownload, isLoading } = useDownloadClassroomCsv();

  return (
    <Wrapper>
      <Button
        leftIcon="FileCsvIcon"
        loading={isLoading}
        dataTestId="school-export-button"
        variant="secondary"
        onClick={onDownload}
      >
        {t('common.export')}
      </Button>

      <SchoolClassroomsDropdown />
    </Wrapper>
  );
}

export { SchoolClassroomsHeader };
